module.exports = __webpack_public_path__ + "static/media/background_library.9afd0661.jpg";